import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';
import * as micropython from './micropython';
import * as tios from './tios';
import * as simulator from './simulator';


export default class SettingsInitializeNode extends BaseNode {
    constructor() {
        super();
        this.name = 'Initialize Settings';
        this.id = 'node_settings_init';
        this.icon = 'TbEraser';
        this.linkedFeature = 'general';

        this.inputs = [
            {
                name: 'Initialize',
                portId: 'stg_init',
                params: [
                ],
            },
        ];
    }

    validate(): ValidationMessage[] {
        const project = this.project;
        const settings = project.getFeature('stg')?.getSettingValue('SETTINGS');
        if (!settings || settings.length === 0) {
            return [{
                message: 'At least one setting must be defined.',
                messageType: ValidationMessageType.ERROR,
                featureId: this.getID(),
            }];
        }
        return [];
    }

    getCodeBlocks(): CodeBlock[] {
        switch (this.project.runtime) {
            case 'micropython':
                return micropython.getCodeBlocks(this);
            case 'simulator':
                return simulator.getCodeBlocks(this);
            default:
                return tios.getCodeBlocks(this);
        }
    }
}
